<template lang="pug">
.doVIDEOFILE
  .title {{cont.stem}}
  <video :src="cont.answer" controls="controls"> your browser does not support the video tag
  </video>
</template>
<script>
export default {
  props: ["cont"],
  created() {
    console.log(this.cont);
  }
};
</script>
<style lang="stylus" scoped>
.doVIDEOFILE
  .title
    font-size 20px
    font-family MicrosoftYaHeiUI-Bold
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    line-height 25px
    margin-bottom 24px
  video
    width 100%
</style>
